module.exports = __webpack_public_path__ + "static/media/crm.03b7e54d.svg";